export default {
  "menu.CompanySelectPage": '场所选择',
};